let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fEATN")).then(() => parcelRequire('153dY'));